import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules'; 
import 'swiper/css';
import 'swiper/css/navigation'; 
import HeaderText from "../helpers/HeaderText";
import { useNavigate } from "react-router-dom";

export default function PriceWise() {
  const items =[
    {imageUrl:require("../../assets/Images/pricewise/1.jpg"),text:"Below ₹99",buttonLink:"#",price:99},
    {imageUrl:require("../../assets/Images/pricewise/2.png"),text:"Below ₹199",buttonLink:"#",price:199},
    {imageUrl:require("../../assets/Images/pricewise/3.png"),text:"Below ₹299",buttonLink:"#",price:299},
    {imageUrl:require("../../assets/Images/pricewise/4.png"),text:"Below ₹399",buttonLink:"#",price:399},
    {imageUrl:require("../../assets/Images/pricewise/5.png"),text:"Below ₹499",buttonLink:"#",price:499},
    {imageUrl:require("../../assets/Images/pricewise/6.jpg"),text:"Below ₹599",buttonLink:"#",price:599},
    {imageUrl:require("../../assets/Images/pricewise/7.jpg"),text:"Below ₹699",buttonLink:"#",price:699},
    {imageUrl:require("../../assets/Images/pricewise/8.png"),text:"Below ₹799",buttonLink:"#",price:799},
    {imageUrl:require("../../assets/Images/pricewise/9.jpg"),text:"Below ₹899",buttonLink:"#",price:899},
  ]

  let navigate = useNavigate();
  const handleTypeClick = (amount) => {
      navigate(`/shop?max_price=${amount}`)
  };

  return (
    <>
      <HeaderText text="Best deals"/>
      
      <div className="col-lg-12 col-md-12 col-sm-12 pt-0 pb-4 relative" style={{ '--swiper-navigation-color': 'black' }}> 
        <Swiper
          modules={[Autoplay, Navigation]} 
          direction="horizontal"
          slidesPerView="auto"
          spaceBetween={10}
          centeredSlides={false}
          loop={true}
          loopAdditionalSlides={0} 
          slidesPerGroup={1}       
          speed={800}               
          autoplay={{
            delay: 2500,           
            reverseDirection: true, 
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          navigation={true} 
          allowTouchMove={true}
          className="queue-right-swiper"
        >
          {items.map((label, i) => (
            <SwiperSlide key={i} onClick={()=>handleTypeClick(label.price)}>
              <div className="queue-card">
                <img src={label.imageUrl} alt={label.text} />
                <div class="title-holder">
                    <h5><span>{label.text}</span></h5>
                    <h6><span>Explore</span></h6>
                </div>
              </div>
            </SwiperSlide>
          ))}
          
 
             
        </Swiper>
        
       
      </div>
    </>
  )
}